import { useQuery } from 'react-query';

import { getActivityCodesByContract as queryFn } from 'api/endPoints/getActivityCodesByContract';

export const useQueryGetActivityCodesByContract = ({ contractId }) => {
    return useQuery<{ scope: string; typeName: string }[], QueryError>(
        ['useQueryGetActivityCodesByContract', contractId],
        () => queryFn(contractId),
        {
            enabled: Boolean(contractId),
        },
    );
};
